
















import Vue from 'vue'
import { FilterItems } from '@/types/service-response'
import moment from 'moment'
import { LOAD_DATES_BY_YEAR } from '@/store/action-types'

interface ComponentData {
  selectedItem: { FilterItemId: string, FilterItemValue: string } | undefined
  selectRules: Array<(v: string) => string | boolean>
  dateItems: Array<FilterItems>
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingWeekSelect',

  props: {
    name: String,
    label: String,
    items: {
      type: Array as () => Array<FilterItems>
    },
    defaultValue: String,
    isRequired: Boolean,
    isValid: Boolean,
    selectedYear: String
  },

  data (): ComponentData {
    return {
      selectedItem: undefined,
      selectRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ],
      dateItems: []
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        form.validate()
      }
    },
    selectedYear (newVal: string) {
      if (newVal) {
        this.loadDateList()
      }
    }
  },

  methods: {

    async loadDateList (): Promise<void> {
      try {
        this.dateItems = []
        const data = await this.$store.dispatch(LOAD_DATES_BY_YEAR, this.selectedYear)
        const weekNumber: string = moment().isoWeek().toString()
        if (this.name === 'KWdatumVon') {
          data.forEach((item: any) => {
            if(weekNumber === item.KW) {
              this.selectedItem = {
                FilterItemId: item.DatumKWvon,
                FilterItemValue: item.KWplusDateVon
              }
            }

            this.dateItems.push({
              FilterItemId: item.DatumKWvon,
              FilterItemValue: item.KWplusDateVon
            })
          })
        }
        if (this.name === 'Von') {
          data.forEach((item: any) => {
            if(weekNumber === item.KW) {
              this.selectedItem = {
                FilterItemId: item.DatumKWvon,
                FilterItemValue: item.KWplusDateVon
              }
            }

            this.dateItems.push({
              FilterItemId: item.DatumKWvon,
              FilterItemValue: item.KWplusDateVon
            })
          })
        }
        if (this.name === 'Bis') {
          data.forEach((item: any) => {
            if(weekNumber === item.KW) {
              this.selectedItem = {
                FilterItemId: item.DatumKWbis,
                FilterItemValue: item.KWplusDateBis
              }
            }

            this.dateItems.push({
              FilterItemId: item.DatumKWbis,
              FilterItemValue: item.KWplusDateBis
            })
          })
        }

        this.onWeekChange()

      } catch (e) {

      }
    },

    onWeekChange (): void {
      if (this.name && this.selectedItem) {
        let payload: Payload = {
          name: this.name,
          value: moment(this.selectedItem.FilterItemId, 'DD-MM-YYYY').format('DD.MM.YYYY' + ' 0:00:00').toString(),
          label: this.selectedItem.FilterItemValue.replace(/\s\s+/g, ' ')
        }
        this.$emit('onWeekChange', payload)
      }
    }
  },

  created () {

  }

})
